module.exports = __webpack_public_path__ + "img/icons/empty-transcript-882c3fb1eda7502ade2f68fee4bf9139.svg";